import React, { useState, useEffect } from 'react';
import { Modal, Button, Badge, ListGroup, Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";

const DeviceListInReportModal = ({ show, onHide, modalData }) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Reset search when modal opens/closes or data changes
  useEffect(() => {
    if (show) {
      setSearchTerm('');
    }
  }, [show, modalData]);

  // Filter and sort shops based on search term
  const filteredAndSortedShops = modalData.shops 
    ? [...modalData.shops]
        .filter(item => {
          // Filter by search term (case insensitive, matches shop number or name or SN)
          if (!searchTerm.trim()) return true;
          
          // Handle both old string format and new object format
          if (typeof item === 'string') {
            return item.toLowerCase().includes(searchTerm.toLowerCase());
          } else if (typeof item === 'object' && item.shop) {
            const searchLower = searchTerm.toLowerCase();
            return (
              item.shop.toLowerCase().includes(searchLower) ||
              (item.sn && item.sn.toLowerCase().includes(searchLower))
            );
          }
          return false;
        })
        .sort((a, b) => {
          // Handle both string and object formats for sorting
          const getShopName = (item) => {
            return typeof item === 'string' ? item : (item.shop || '');
          };
          
          const shopA = getShopName(a);
          const shopB = getShopName(b);
          
          // Extract numbers from strings for numeric comparison
          const numA = parseInt(shopA.replace(/\D/g, ''), 10);
          const numB = parseInt(shopB.replace(/\D/g, ''), 10);
          
          // If both are valid numbers, sort numerically
          if (!isNaN(numA) && !isNaN(numB)) {
            return numA - numB;
          }
          
          // Otherwise, sort alphabetically
          return shopA.localeCompare(shopB, 'pl', { numeric: true });
        })
    : [];

  const clearSearch = () => {
    setSearchTerm('');
  };

  
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{modalData.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {modalData.shops && modalData.shops.length > 0 ? (
          <div>
            <div className="mb-3">
              <Badge bg="secondary" className="me-2">
                Łącznie: {modalData.shops.length} drogerii
              </Badge>
              {searchTerm && (
                <Badge bg="info" className="me-2">
                  Znaleziono: {filteredAndSortedShops.length}
                </Badge>
              )}
            </div>
            
            {/* Search Input */}
            <div className="mb-3">
              <InputGroup>
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Wpisz numer drogerii, część nazwy lub numer seryjny..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  autoFocus
                />
                {searchTerm && (
                  <Button 
                    variant="outline-secondary" 
                    onClick={clearSearch}
                    style={{ borderLeft: 'none' }}
                  >
                    <FontAwesomeIcon icon={faTimes} />
                  </Button>
                )}
              </InputGroup>
              {searchTerm && filteredAndSortedShops.length === 0 && (
                <small className="text-muted mt-1 d-block">
                  Brak drogerii pasujących do wyszukiwanego terminu "{searchTerm}"
                </small>
              )}
            </div>
            
            <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
              <ListGroup variant="flush">
                {filteredAndSortedShops.map((item, index) => (
                  <ListGroup.Item key={index} className="d-flex justify-content-between align-items-center">
                    <div>
                      <span className="fw-bold">
                       <Link 
                         to={`/shopview/name/${typeof item === 'string' ? item : item.shop}`}
                         target="_blank"
                         rel="noopener noreferrer"
                       >
                         {typeof item === 'string' ? item : item.shop}
                       </Link>
                      </span>
                      {typeof item === 'object' && item.sn && (
                        <div className="text-muted small" style={{overflowWrap: "break-word"}}>
                          SN: {item.sn.map(sn => (<span key={sn}>{sn} </span>))}
                        </div>
                      )}
                    </div>
                    
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
          </div>
        ) : (
          <div className="text-center p-4 text-muted">
            <FontAwesomeIcon icon={faStore} size="2x" className="mb-2" />
            <p className="mb-0">Brak drogerii w tej kategorii</p>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Zamknij
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeviceListInReportModal;
